import { Tooltip } from '@mantine/core';
import { FC } from 'react';

import Paragraph from '@/components/text/Paragraph.tsx';

import StatusDotType from '@/models/StatusDotType.ts';

import StatusDot from '../StatusDot.tsx';

interface Props {
    text: string;
    color: string;
}

const CalendarFilterItem: FC<Props> = ({ text, color }) => {
    const displayText: string = text.length > 30 ? `${text.slice(0, 27)}...` : text;

    return (
        <Tooltip label={text} openDelay={300}>
            <div className="flex items-center gap-1.5">
                <StatusDot type={StatusDotType.GENERIC} size={10} color={color} />
                <Paragraph className="max-w-[240px] truncate">{displayText}</Paragraph>
            </div>
        </Tooltip>
    );
};

export default CalendarFilterItem;
